// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"796ad253","933":"4f2190e8"}[chunkId] + ".chunk.js";
};